module.exports = __webpack_public_path__ + "img/elitetrading_logo.ffed99c1.png";